import * as types from 'constants/actionTypes'

const initialState = {}

export default function (state = initialState, action) {
  switch (action.type) {
    case types.RECEIVE_ORDERS_DATA:
      return {
        ...state,
        data: action.data
      }

    case types.SET_ANALYTICS_DATES_RANGE:
      return {
        ...state,
        datesRange: action.datesRange,
        data: null
      }

    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/shopifyAnalytics.js